import { ProgrammeHero } from '@/components/work-with-me/ProgrammeHero'
import { ProgrammePricing } from '@/components/work-with-me/ProgrammePricing'
import { ProgrammeIncluded } from '@/components/work-with-me/ProgrammeIncluded'
import { ProgrammeJourney } from '@/components/work-with-me/ProgrammeJourney'
import { ProgrammePersonalisation } from '@/components/work-with-me/ProgrammePersonalisation'

export const WorkWithMePage = () => (
  <>
    <ProgrammeHero />

    <ProgrammePricing />

    <ProgrammeIncluded />

    <ProgrammeJourney />

    <ProgrammePersonalisation />
  </>
)
